export const isWemeetApp = () => {
  if (typeof wemeet !== 'undefined') {
    const { app } = wemeet;
    return app.isTMWebview();
  }
  return false;
};
